// @ts-ignore
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

import { useMediaQuery } from "react-responsive";

const TourContext = createContext();


export const TourProvider = ({ children }) => {
  const [tourType, setTourType] = useState("home");
  const [showTour, setShowTour] = useState(false);
  const [tourStep, setTourStep] = useState(1);
  const [steps, setSteps] = useState(5);

  const isTablet = useMediaQuery({ maxWidth: 1100 });
  const isMobile = useMediaQuery({ maxWidth: 620 });

  useEffect(() => {
    if (showTour && (isTablet || isMobile)) setShowTour(false);
  }, [showTour, isTablet, isMobile]);

  const navigationTour = useCallback(
    (event) => {
      const tecla = event.keyCode;
      switch (tecla) {
        case 39: {
          const newStep = tourStep + 1;
          if (newStep > steps) break;
          setTourStep(newStep);
          break;
        }
        case 37: {
          const newStep = tourStep - 1;
          if (newStep < 1) break;
          setTourStep(newStep);
          break;
        }
        case 27:
          setTourStep(1);
          setShowTour(false);
          break;
        default:
          break;
      }
    },
    [tourStep, steps]
  );

  useEffect(() => {
    document.addEventListener("keydown", navigationTour, true);

    return () => {
      document.removeEventListener("keydown", navigationTour, true);
    };
  }, [navigationTour]);

  return (
    <TourContext.Provider
      value={{
        showTour,
        setShowTour,
        tourType,
        setTourType,
        tourStep,
        setTourStep,
        setSteps,
        steps,
      }}
    >
      {children}
    </TourContext.Provider>
  );
};

export function useTour() {
  return useContext(TourContext);
}
